/* =============================================
   LFmina – JavaScript
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Nav scroll effect --- */
  const nav = document.getElementById('siteNav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  /* --- Mobile menu --- */
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  const closeMenu = document.getElementById('closeMenu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.add('open');
    });
  }
  if (closeMenu && mobileMenu) {
    closeMenu.addEventListener('click', function () {
      mobileMenu.classList.remove('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
      });
    });
  }

  /* --- Scroll reveal --- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* --- Float CTA --- */
  const floatCta = document.getElementById('floatCta');
  if (floatCta) {
    window.addEventListener('scroll', function () {
      floatCta.classList.toggle('visible', window.scrollY > 600);
    });
  }

  /* --- FAQ accordion --- */
  document.querySelectorAll('.faq-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* --- Product filter --- */
  const filterBtns = document.querySelectorAll('.filter-pill');
  const productCards = document.querySelectorAll('#productGrid .product-card');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      productCards.forEach(function (card) {
        if (filter === 'all' || card.dataset.cat === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* --- Contact form toast --- */
  const form = document.getElementById('leadForm');
  const toast = document.getElementById('toast');
  if (form && toast) {
    form.addEventListener('submit', function () {
      setTimeout(function () {
        toast.classList.add('show');
        setTimeout(function () { toast.classList.remove('show'); }, 4000);
      }, 500);
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});

/* Keep interactive modules working while sections are edited in Shopify. */
document.addEventListener('shopify:section:load', function (event) {
  const root = event.target;

  root.querySelectorAll('.reveal').forEach(function (el) {
    el.classList.add('visible');
  });

  root.querySelectorAll('.faq-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      root.querySelectorAll('.faq-item').forEach(function (entry) { entry.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  const filterButtons = root.querySelectorAll('.filter-pill');
  const productCards = root.querySelectorAll('#productGrid .product-card');
  filterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterButtons.forEach(function (entry) { entry.classList.remove('active'); });
      btn.classList.add('active');
      productCards.forEach(function (card) {
        card.style.display = btn.dataset.filter === 'all' || card.dataset.cat === btn.dataset.filter ? '' : 'none';
      });
    });
  });
});
